var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{ref:"textarea",attrs:{"type":"textarea","rows":_vm.rows},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }